//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * mt-header
 * @module components/header
 * @desc 顶部导航
 * @param {boolean} [router] - 是否启动路由
 * @param {String} [to] - 该属性只有在启动自动路由时有效，设定左图标的路由地址
 * @param {String} [leftIcontext] - 该属性只有在启动自动路由时有效，设定左图标的关联文本
 * @param {String} [backgroundColor] - 设定header的背颜色
 * @param {String} [color] - 设定header的文本字体颜色
 * @param {String} [fontSize] - 设定header的文本字体大小
 * @param {String} [height] - 设定header的高度
 * @param {boolean} [fixed=false] - 固定顶部
 * @param {string} [title] - 标题
 * @param {slot} [left] - 显示在左侧区域
 * @param {slot} [right] - 显示在右侧区域
 *
 * @example
 * <mt-header title="我是标题" fixed>
 *   <mt-button slot="left" icon="back" @click="handleBack">返回</mt-button>
 *   <mt-button slot="right" icon="more"></mt-button>
 * </mt-header>
 */
export default {
  name: 'mt-header',

  props: {
    router:Boolean,
    to:{
      type:String,
      default:"/"
    },
    leftIcontext:{
      type:String,
      default:""
    },
    backgroundColor:{
      type:String,
      default:"mt-bg-lv2"
    },
    color:{
      type:String,
      default:"mt-color-grey"
    },
    fontSize:{
      type:String,
      default:"18px"
    },
    height:{
      type:String,
      default:"44px"
    },
    fixed: Boolean,
    title: String
  }
};



// WEBPACK FOOTER //
// ./packages/header/src/header.vue